import React from 'react';

export default function Footer({ t }) {
  return (
    <footer className="border-t border-rule px-8 py-7 font-mono text-xs text-ink-3 text-center tracking-[0.04em]">
      {t.footer}
    </footer>
  );
}
